function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      document.querySelector('body').classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    // const detailsElement = event.currentTarget.closest('details');
    // this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header') || document.getElementById('shopify-section-header-synternals') || document.getElementById('shopify-section-header-super-serum-page');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);
const VARIANT_SELECTOR_SELECTOR = "[data-variant-selector]";
const THUMBNAIL_CONTAINER_SELECTOR = ".product-gallery__nav";
const THUMBNAIL_SELECTOR = ".product-gallery__images";
const THUMBNAIL_SELECTOR_MOBILE = ".product__info-wrapper";
const PRODUCT_GALLERY = "product-gallery";

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.addOptionDefault();
    this.createCustomSelects();
    this.carouselContainer = document.querySelector(THUMBNAIL_SELECTOR);
    this.carouselContainerMobile = document.querySelector(THUMBNAIL_SELECTOR_MOBILE);
    this.thumbnailContainer = document.querySelector(THUMBNAIL_CONTAINER_SELECTOR);
    this.productGallery = document.querySelector(PRODUCT_GALLERY);
    const productJsonEl = document.querySelector('#data-product-json');
    this.data = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
  }

  isCardPicker() {
    return this.hasAttribute('data-card-picker');
  }

  getSelectShadeLabel() {
    return (window.product && window.product.select_shade) ||
      (window.variantStrings && window.variantStrings.selectShade) ||
      'Select Shade';
  }

  getAddToCartLabel() {
    return (window.product && window.product.add_to_cart) ||
      (window.variantStrings && window.variantStrings.addToCart) ||
      'Add to bag';
  }

  syncCardPickerState() {
    if (!this.isCardPicker()) return;

    const select = this.querySelector('select.select__select');
    if (!select) return;

    const buttons = Array.from(this.querySelectorAll('.btn-add-to-cart'));

    if (select.value === 'N/A') {
      buttons.forEach((btn) => {
        btn.textContent = this.getSelectShadeLabel();
        btn.removeAttribute('data-id');
        if (typeof jQuery !== 'undefined') {
          jQuery(btn).removeData('id');
        }
      });
      return;
    }

    if (!this.currentVariant) {
      this.updateOptions();
      this.updateMasterId();
    }

    if (!this.currentVariant) return;

    buttons.forEach((btn) => {
      btn.textContent = this.getAddToCartLabel();
      btn.setAttribute('data-id', this.currentVariant.id);
      if (typeof jQuery !== 'undefined') {
        jQuery(btn).data('id', this.currentVariant.id);
      }
    });
  }

  renderCardPlaceholder(customSelect, placeholder) {
    customSelect.classList.add('is-empty');
    placeholder.innerHTML = '<div class="option-inner option-inner--empty"><span class="icon icon--empty" aria-hidden="true"></span></div>';
  }

  renderCardSwatch(customSelect, placeholder, color) {
    customSelect.classList.remove('is-empty');
    const colorAttr = color ? ` style="background-color: ${color}"` : '';
    placeholder.innerHTML = `<div class="option-inner"><span class="icon"${colorAttr} aria-hidden="true"></span></div>`;
  }

  getCardOuterAtcButton() {
    return Array.from(this.querySelectorAll('.btn-add-to-cart')).find(
      (btn) => !btn.closest('.custom-select-options')
    ) || null;
  }

  showCardPickerAtcError() {
    const outerBtn = this.getCardOuterAtcButton();
    if (!outerBtn || typeof jQuery === 'undefined') return;

    const btn = jQuery(outerBtn);
    if (btn.next().hasClass('add-cart-error')) return;

    const message =
      (window.variantStrings && window.variantStrings.selectOption) ||
      'Please select an option';

    const messageEl = jQuery('<div>')
      .append(jQuery('<span>').text(message))
      .addClass('add-cart-error');

    messageEl.insertAfter(btn);

    setTimeout(() => {
      messageEl.fadeOut(function () {
        messageEl.remove();
      });
    }, 2500);
  }

  handleCardPickerPanelClose(customSelect, originalSelect) {
    if (!this.isCardPicker() || !customSelect || !originalSelect) return;

    if (
      originalSelect.value === 'N/A' &&
      customSelect.dataset.openedFromAtc === 'true'
    ) {
      this.showCardPickerAtcError();
    }

    delete customSelect.dataset.openedFromAtc;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (this.isCardPicker()) {
      this.syncCardPickerState();
      return;
    }

    this.toggleAddButton(false, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      // Keep the add-to-cart button enabled even when no variant is selected
      // (placeholder "N/A"). The selection is validated on submit instead.
      this.toggleAddButton(false, '', true);
      this.setUnavailable();
      this.activeMedia(0);
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  /**
   * create custom select by config isCustom
   */
  createCustomSelects() {
    let selects = this.querySelectorAll('select.select__select');
    let _this = this;
    selects.forEach(function(item) {
      if(item.dataset.isCustom) {
        _this.createCustomSelect(item);
      }
    })
  }

  /**
   * create custom select follow original select
   *
   * @param {*} originalSelect
   * @returns
   */
  createCustomSelect(originalSelect) {
    if(!originalSelect) return;
    let _this = this;
    let optionValue = {};
    let newSelect = this.createElementByString(`
      <div class="custom-select">
      </div>
    `);
    let selectInput = this.createElementByString(`
      <div class="select__select custom-select-input">
          <span class="custom-select-placeholder"></span>
      </div>
    `)
    let optionsElement = this.createElementByString(`
      <ul class="option-container">

      </ul>
    `);
    let optionsContainerElement = this.createElementByString(`
      <div class="custom-select-options">

      </div>
    `);
    let titleElement = this.createElementByString(`
      <span class="swatch-dropdown-title">Select your shade</span>
    `);
    let closeToggleElement = this.createElementByString(`
      <label class="swatch-dropdown-close-btn"></label>
    `);
    let cloneAddToCartBtn = null;
    const variantSelectsHost = originalSelect.closest('variant-selects');
    const sourceAtcBtn = variantSelectsHost && Array.from(variantSelectsHost.querySelectorAll('.btn-add-to-cart')).find(
      (btn) => !btn.closest('.custom-select-options')
    );

    if (sourceAtcBtn) {
      cloneAddToCartBtn = sourceAtcBtn.cloneNode(true);
    }
    let option = originalSelect.querySelectorAll('option');
    option = Array.from(option);
    const isCardPickerHost = variantSelectsHost && variantSelectsHost.hasAttribute('data-card-picker');
    option.forEach(function(item){
      let _value = item.getAttribute('value');
      let _color = item.dataset.color;
      let _label = item.text;
      let _option = _this.createCustomOptionSelect(_color, _value, _label)

      // Card picker: N/A stays in native select only, not in the swatch list
      if (_value === "N/A" && isCardPickerHost) {
        return;
      }

      // If data-value is "N/A", add disabled attribute
      if (_value === "N/A") {
        _option.setAttribute('disabled', 'disabled');
        _option.classList.add('disabled');
      }

      if (_value) {
        optionValue[_value] = {
          label: _label,
          color: _color,
          element: _option
        };
        optionsElement.appendChild(_option);
      }
    });
    // add input in select container
    newSelect.appendChild(selectInput);
    // add option in select container
    optionsContainerElement.appendChild(titleElement);
    optionsContainerElement.appendChild(closeToggleElement);
    optionsContainerElement.appendChild(optionsElement);
    cloneAddToCartBtn && optionsContainerElement.appendChild(cloneAddToCartBtn);
    newSelect.appendChild(optionsContainerElement);

    // init function of custom select
    this.createHandleCustomSelect(originalSelect, newSelect, optionValue);

    // add custom select before original select
    originalSelect.parentNode.insertBefore(newSelect, originalSelect.nextSibling)
  }

  /**
   *
   * @param { HTMLElement } originalSelect
   * @param {HTMLElement} newSelect
   * @param { object } optionValue
   */
  createHandleCustomSelect(originalSelect, newSelect, optionValue) {
    let _this = this;
    let idOriginalSelect = originalSelect.getAttribute('id');
    let placeholder = newSelect.querySelector('.custom-select-placeholder');
    const variantSelectsEl = originalSelect.closest('variant-selects');
    const isCardPicker = variantSelectsEl && variantSelectsEl.hasAttribute('data-card-picker');
    let optionSelected = originalSelect.querySelector('option[selected]');

    if (isCardPicker && originalSelect.value === 'N/A') {
      _this.renderCardPlaceholder(newSelect, placeholder);
    } else if (isCardPicker && originalSelect.value !== 'N/A') {
      const selectedColor =
        optionValue[originalSelect.value]?.color ||
        Array.from(originalSelect.options).find((opt) => opt.value === originalSelect.value)?.dataset.color;
      _this.renderCardSwatch(newSelect, placeholder, selectedColor);
    } else if(optionSelected && optionSelected.getAttribute('value') != "") {
      placeholder.innerHTML = optionValue[optionSelected.getAttribute('value')].element.innerHTML;
    } else if (originalSelect.querySelector('option').getAttribute('value') != ""){
      placeholder.innerHTML = optionValue[originalSelect.querySelector('option').getAttribute('value')].element.innerHTML;
    }

    originalSelect.addEventListener('change', function() {
      let value = originalSelect.value;

      if (isCardPicker) {
        if (value === 'N/A') {
          _this.renderCardPlaceholder(newSelect, placeholder);
        } else {
          const selectedColor =
            optionValue[value]?.color ||
            Array.from(originalSelect.options).find((opt) => opt.value === value)?.dataset.color;
          _this.renderCardSwatch(newSelect, placeholder, selectedColor);

          const titleEl = newSelect.querySelector('.swatch-dropdown-title');
          if (titleEl && optionValue[value]) {
            titleEl.textContent = optionValue[value].label;
          }
        }

        if (variantSelectsEl && typeof variantSelectsEl.syncCardPickerState === 'function') {
          variantSelectsEl.syncCardPickerState();
        }
        return;
      }

      let label = optionValue[value].element.innerHTML;
      placeholder.innerHTML = label;
    });

    newSelect.classList.add(idOriginalSelect);
    let newSelectOption = newSelect.querySelectorAll('.option');

    newSelectOption.forEach(function(item){
      item.addEventListener('click', function(e) {
        if(item.classList.contains('selected')) return;

        newSelectOption.forEach(function(option) {
          option.classList.remove('selected');
        })

        item.classList.add('selected');

        let value = item.dataset.value;
        let label = optionValue[value].element.innerHTML;

        if (value && value !== 'N/A') {
          originalSelect.value = value;
          delete newSelect.dataset.openedFromAtc;

          if (isCardPicker) {
            const selectedColor =
              optionValue[value]?.color ||
              Array.from(originalSelect.options).find((opt) => opt.value === value)?.dataset.color;
            _this.renderCardSwatch(newSelect, placeholder, selectedColor);

            const titleEl = newSelect.querySelector('.swatch-dropdown-title');
            if (titleEl && optionValue[value]) {
              titleEl.textContent = optionValue[value].label;
            }
          } else {
            placeholder.innerHTML = label;
          }

          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
    })

    newSelect.addEventListener('click', this.customSelectToggle);
    newSelect.querySelector('.swatch-dropdown-close-btn').addEventListener('click', function(e){
      e.stopImmediatePropagation();
      _this.customSelectToggle.bind(newSelect)();
    });

    document.addEventListener('click', function(e){
      // CDSD-26305: Not in NZ store
      // && e.target.offsetHeight > 0
      // && e.target.offsetWidth > 0
      if(
        !e.target.closest('.' + idOriginalSelect)
        && e.target.offsetHeight > 0
        && e.target.offsetWidth > 0
        && newSelect.classList.contains('open')
      ) {
        newSelect.classList.remove('open');
        if (variantSelectsEl && typeof variantSelectsEl.handleCardPickerPanelClose === 'function') {
          variantSelectsEl.handleCardPickerPanelClose(newSelect, originalSelect);
        }
      }
    });

    originalSelect.parentElement.classList.add('show_custom_select');

    if (isCardPicker && variantSelectsEl && typeof variantSelectsEl.syncCardPickerState === 'function') {
      variantSelectsEl.syncCardPickerState();
    }
  }
  customSelectToggle() {
    if(window.matchMedia('(max-width: 767px)').matches) {
      if(
          event.target.closest('.boost-pfs-filter-right-col')
          && event.target.closest('.custom-select-options')
          && !event.target.classList.contains('swatch-dropdown-close-btn')
      ) {
        return;
      }
    }

    const wasOpen = this.classList.contains('open');

    if(wasOpen) {
      this.classList.remove('open');
      const variantSelects = this.closest('variant-selects');
      const originalSelect = variantSelects?.querySelector('select.select__select');
      if (variantSelects && typeof variantSelects.handleCardPickerPanelClose === 'function') {
        variantSelects.handleCardPickerPanelClose(this, originalSelect);
      }
    } else {
      document.getElementsByClassName(this.className).forEach(function(selectElem){
        selectElem.classList.remove('open');
      });
      //set --data-.. to :root, make dynamic css with var(--data-..)
      document.documentElement.style.setProperty('--custom-select-options--height', this.querySelector('.custom-select-options').offsetHeight+ 'px');

      this.classList.add('open')
    }
  }
  /**
   * create option element of custom select
   *
   * @param { string } color
   * @param { string } value
   * @param { string } label
   * @returns HTMLElement
   */
  createCustomOptionSelect (color, value, label){
    let option = this.createElementByString(`
      <li class="option" data-value="${value}" data-label="${label}">
          <div class="option-inner">
            <span class="icon ${color?'':'hidden'}"  ${color?('style="background-color: ' + color + '"') : ''} > </span>
            <span class="label">${label}</span>
          </div>
      </li>
    `);

    return option;
  }
  createElementByString(string) {
    var div = document.createElement('div');
    div.innerHTML = string.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  }

  /**
   * add option placeholder for origin select
   */
  addOptionDefault() {
    let selects = this.querySelectorAll('select.select__select');
    let _this = this;
    let isChange = false;
    selects.forEach(function(elementSelect) {
      let name = elementSelect.dataset.optionDefaultLabel ?? 'Select option';
      let selected = 'selected="selected"';

      elementSelect.querySelectorAll('option').forEach(function(item){
        if(selected && item.getAttribute('selected')) {
          selected = '';
        }
      })

      /*let defaultOption = _this.createElementByString(`
          <option value="" ${selected}>${name}</option>
      `);*/

      //elementSelect.insertBefore(defaultOption, elementSelect.querySelector('option'));

      if(!isChange && selected) isChange = true;
    })

    //if(isChange) {
      window.addEventListener('DOMContentLoaded', (event) => {
        _this.dispatchEvent(new Event('change'));
      });
    //}
  }

  activeMedia (id = 0) {
    document.querySelector('body').dispatchEvent(new CustomEvent('change_media', { 'bubbles': true, 'detail': {'currentVariant': `${id}`} }))
  }

  changeVariantMedia (id = 0) {
    document.querySelector('body').dispatchEvent(new CustomEvent('changeMediaSlider', { 'bubbles': true, 'detail': {'currentVariant': `${id}`} }))
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    const variantData = this.getProductVariantData(this.currentVariant.id);
    const product = variantData.product;
    const colorIndex = product.options.findIndex((option) => ["color", "colour"].includes(option.toLowerCase()));
    if (colorIndex !== -1) {
      const vColor = variantData.options[colorIndex].toLowerCase();
      let thumbsHtml = "";
      let imageHtml = "";
      let position = 0;
      const imagesOverlay = window.imageOverlay
      let imagesOverlayHTML = ''
      if(imagesOverlay) {
        imagesOverlay.forEach((image)=> {
          imagesOverlayHTML += `<img src="${image.src}" alt="${image.alt}" >`
        })
      }

      product.media.forEach((mediaItem, i) => {
        let color = "all";
        if (mediaItem.alt) {
          const splitAlt = this.handlize(mediaItem.alt).split(this.handlize(product.title));
          if (splitAlt.length > 1) {
            color = this.handlize(splitAlt[1].replace(/[^a-zA-Z\S]/g, "").trim()) || "all";
            while (color.startsWith("-"))
              color = color.substr(1);
            while (color.endsWith("-"))
              color = color.slice(0, -1);
          }
        }

        if (this.handlize(color) != this.handlize(vColor))
          return;

        if (mediaItem.media_type === "image") {
          thumbsHtml += `<li class="product-gallery__nav-item ${(position > 0 ?'':'active')}" data-media-id="${mediaItem.id}">
                          <div class="product__media media" style="padding-top: 100%;">
                            <img src="${mediaItem.src}" loading="lazy" width="152" height="152" alt="${mediaItem.alt}">
                          </div>
                        </li>`;
          imageHtml += `<div class="product-gallery__image ${(position > 0 ?'':'product-gallery__image--active')}" data-media-id="${mediaItem.id}">
                          <noscript><div class="product__media media" style="padding-top: 100.0%;">
                                <img
                                  src="${mediaItem.src}"
                                  loading="lazy"
                                  width="576"
                                  class="original-image"
                                  height="576"
                                  alt="${mediaItem.alt}"
                                >
                              </div></noscript>
                          <div class="label-image-product">
                          </div>
                          <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#ProductModal-">
                            <div class="product__media media media--transparent" style="padding-top: 100.0%;">
                              <img src="${mediaItem.src}" loading="lazy" width="576" class="original-image" height="576" alt="${mediaItem.alt}">
                              <div class="image-overlay">${imagesOverlayHTML}</div>
                            </div>
                          </modal-opener>
                          </div>`;
        }

        position++;
      });

      const galleryImages = document.querySelector('.custom-layout-product');
      const childGalleryImages = galleryImages.querySelectorAll('.product-gallery__image');

      // Iterate through the elements and remove them
      childGalleryImages.forEach(element => {
        element.remove();
      });

      this.carouselContainer.insertAdjacentHTML('afterbegin', imageHtml);
      this.thumbnailContainer.innerHTML = thumbsHtml;
      this.productGallery.init();
    }

    this.activeMedia(
      this.currentVariant.featured_media ?
      this.currentVariant.featured_media.id :
      0
    );

    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const updateHtml = [ '.afterpay'];

        updateHtml.forEach(function(item) {
          let updateBy = document.querySelector(item);
          let newData = html.querySelector(item);
          updateBy && newData && (updateBy.innerHTML = newData.innerHTML);
        })

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.querySelector('.btn-text').textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.querySelector('.btn-text').textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.querySelector('.btn-text').textContent = window.variantStrings.addToCart;
    // if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getProductVariantData(variantId) {
    if (!this.data) return null;
    if (!variantId) {
      variantId = this.getSelectedVariantId();
    }
    const targetVariant = this.data.variants.find((variant) => variant.id == variantId);
    return { ...targetVariant, product: this.getProductData() };
  }

  getSelectedVariantId() {
    return this.currentVariant.id;
  }

  getProductData() {
    const product = { ...this.data };
    product.variants = product.variants.map((variant) => {
      return {
        ...variant,
        product: product
      };
    });
    return product;
  }

  handlize (inputString) {
    var str = inputString.toLowerCase();
    ['"', "'", "\\", "(", ")", "[", "]"].forEach(function(phrase) {
      return str = str.replace(phrase, "");
    });
    str = str.replace(/\W+/g, "-");
    while (str.startsWith("-"))
      str = str.substr(1);
    while (str.endsWith("-"))
      str = str.slice(0, -1);
    return str;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

const initGlobalSlider = (options = {}) => {
  const defaultOptions = {
    selector: '.slider',
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 700,
    infinite: true,
    arrows: true,
    dots: false,
    centerMode: false,
    prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-chevron-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fal fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false
        },
      },
    ],
    enableResize: false,
    onInit: () => {}
  };

  const settings = { ...defaultOptions, ...options };

  const $slider = $(`${settings.selector}`);
  if ($slider.hasClass("slick-initialized")) return;

  const initSlider = () => {
    $(settings.selector).slick({
      infinite: settings.infinite,
      slidesToShow: settings.slidesToShow,
      slidesToScroll: settings.slidesToScroll,
      speed: settings.speed,
      arrows: settings.arrows,
      dots: settings.dots,
      centerMode: settings.centerMode,
      prevArrow: settings.prevArrow,
      nextArrow: settings.nextArrow,
      responsive: settings.responsive,
    });

    settings.onInit($slider);
  };

  initSlider();

  settings.enableResize && $(window).on('resize', debounce(initSlider, 300));
};